import React from "react";
import { withRouter } from "react-router-dom";
import CourseThemeContext from "../../core/CourseThemeContext";
import Icon from "../../core/Icon";
import ColumnSeparator from "../../core/ColumnSeparator";
import TranslatedText from "../../core/TranslatedText";
import Separator from "../../core/Separator";

const CertificationTestFinishedPanel = () => (
  <CourseThemeContext.Consumer>
    {({ primary }) => (
      <div
        style={{
          width: 600,
          borderRadius: 4,
          backgroundColor: primary,
          padding: "12px 24px",
          display: "flex",
          alignItems: "center",
          margin: "0 auto",
        }}
      >
        <Icon icon="check" color="#00786A" size="xl" />
        <ColumnSeparator size="md" />
        <ColumnSeparator size="xs" />
        <div>
          <TranslatedText
            as="p"
            translateKey="certificationTest.execution.completedTitle"
            style={{
              margin: 0,
              color: "#fff",
              fontWeight: "bold",
              fontSize: 16,
            }}
          />
          <Separator />
          <TranslatedText
            as="p"
            translateKey="certificationTest.execution.completedDescription"
            style={{
              margin: 0,
              color: "#fff",
              fontSize: 14,
            }}
          />
        </div>
      </div>
    )}
  </CourseThemeContext.Consumer>
);

export default withRouter(CertificationTestFinishedPanel);
